import { Input } from 'reactstrap';
import React from 'react';

export interface ISimpleSelectProps {
    className: string;
    id: string;
    name: string;
    options: string[] | { id: string | number; name: string }[];
    value: string | number | undefined;
    onChange: (value: string) => void;
    disabled: boolean;
    selectedValue?: string;
}

const SimpleSelect = (props: ISimpleSelectProps): JSX.Element => {
    return (
        <Input
            disabled={props.disabled}
            id={props.id}
            className={props.className}
            type="select"
            bsSize="sm"
            name={props.name}
            onChange={(e: { target: { value: string } }) => props.onChange(`${e.target.value}`)}
            value={props.value}
        >
            {props.options.map((option: any, i: number) => (
                <option key={i} value={option.id}>
                    {option.name || option}
                </option>
            ))}
        </Input>
    );
};

export default SimpleSelect;
